<template>
    <div>
        <div id="convert-error" class="" role="alert">
            <div class="container">
                <div class="text-center">
                    <div>
                        <!-- <span class="conver-error-title">Sorry</span><i class="far fa-frown"></i> -->
                    </div>
                    <div class="output-error-text" v-html="getErrorMessage()"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorBlock',
    props: {
        error: {
            type: [Object, Boolean],
            default: null
        },
    },
    methods: {
        getErrorMessage() {
            if (this.error && Object.keys(this.error).includes('message')) {
                return this.error.message;
            }
            return 'Sorry, it seems that the link is not valid :(<br>Please, try again.';
        }
    }
}
</script>

<style scoped>
.conver-error-action-text {
    color: #ff5916;
}
</style>